module.exports = require("core-js/library/fn/parse-int");


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime-corejs2@7.20.1@@babel/runtime-corejs2/core-js/parse-int.js
// module id = sYRw
// module chunks = 0